// extracted by mini-css-extract-plugin
export default {"SelectRing":"SelectRing_SelectRing__S0M7n","title":"SelectRing_title__t+ku3","actions":"SelectRing_actions__2dlhR"};